import { render } from "./FinishFrame.html?vue&type=template&id=54120fd3&scoped=true"
import script from "./FinishFrame.js?vue&type=script&lang=js"
export * from "./FinishFrame.js?vue&type=script&lang=js"

import "./FinishFrame.scss?vue&type=style&index=0&id=54120fd3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54120fd3"]])

export default __exports__